const jaywanLogo = require('./images/jaywan-logo.svg')
const fallbackVisaLogo = require('../../PaymentMethodIcon/images/mini/visa.png')
const fallbackMastercardLogo = require('../../PaymentMethodIcon/images/mini/mastercard.png')

const fallbackCardBrandIcons = [
  { brand: 'visa', iconUrl: fallbackVisaLogo },
  { brand: 'mastercard', iconUrl: fallbackMastercardLogo },
]

const getCardBrand = (item = {}) => {
  return String(item.brand || item.cardBrand || '').toLowerCase()
}

export const getCardBrandIconKey = (item = {}) => {
  return item.brand || item.cardBrand || item.iconUrl
}

export const getSupportedCardIconsFromPayMethods = (payMethods = []) => {
  try {
    const cardMethod = payMethods.find((method) => method.type === 'CARD_TOKEN')
    const supportedCardBrandIcons = cardMethod &&
      cardMethod.payMethodExtension &&
      cardMethod.payMethodExtension.supportedCardBrandIcons

    if (!supportedCardBrandIcons) {
      return []
    }

    const icons = JSON.parse(supportedCardBrandIcons)

    return Array.isArray(icons) ? icons : []
  } catch (e) {
    return []
  }
}

export const getCardBrandIconsWithJaywanAfterVisa = (
  supportedCardIcons = [],
  useFallback = false
) => {
  const sourceIcons = supportedCardIcons.length
    ? supportedCardIcons
    : useFallback
      ? fallbackCardBrandIcons
      : []
  const iconsWithoutJaywan = sourceIcons.filter((item) => {
    return getCardBrand(item) !== 'jaywan'
  })
  const visaIndex = iconsWithoutJaywan.findIndex((item) => {
    return getCardBrand(item) === 'visa'
  })
  const insertIndex = visaIndex > -1 ? visaIndex + 1 : 0

  return [
    ...iconsWithoutJaywan.slice(0, insertIndex),
    { brand: 'jaywan', iconUrl: jaywanLogo },
    ...iconsWithoutJaywan.slice(insertIndex),
  ]
}
